import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AlertComponent {
  public message: string;
  public helpText: string;
  public type: string;

  constructor(public dialogRef: MatDialogRef<AlertComponent>) {}
}
